import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { LogoMark } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Ctx = createContext(null);

function Loader() {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink" data-testid="site-loader">
      <LogoMark className="h-14 w-16 animate-pulse" />
    </div>
  );
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const load = () =>
    axios
      .get(`${API}/content`)
      .then((r) => setContent(r.data.sections || {}))
      .catch(() => setContent({}));

  useEffect(() => {
    load();
  }, []);

  const api = {
    content,
    refresh: load,
    get: (section, field, fallback = "") => content?.[section]?.[field] ?? fallback,
    lines: (section, field) =>
      (content?.[section]?.[field] || "")
        .split("\n")
        .map((x) => x.trim())
        .filter(Boolean),
    pairs: (section, field) =>
      (content?.[section]?.[field] || "")
        .split("\n")
        .map((x) => x.trim())
        .filter(Boolean)
        .map((l) => l.split("|").map((x) => x.trim())),
  };

  if (!content) return <Loader />;
  return <Ctx.Provider value={api}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);
